<template>
  <div class="move-org">
    <div class="format-content">
      <v-card>
        <div class="header">
          <v-card-title>
            <span>Move Vehicle(s) to Organisation</span> 
            <v-spacer/> 
            <v-icon color="white" @click="close">mdi-close</v-icon>
          </v-card-title>
        </div>
        
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select 
                v-model="selectedOrg"
                label="Organisation" 
                :items="orgNameAndIdList"
                item-text="name"
                item-value="id"
                ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select 
                v-model="selectedGroup"
                label="Group" 
                :items="orgGroups"
                :loading="orgTreeLoading"
                item-text="name"
                item-value="id"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="close">
            cancel
          </v-btn>
          <v-btn text :loading="loading" :disabled="disableSubmit || loading" @click="moveVehicles">
            move
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </div>    
  </div>
</template>

<script>

import { GetOrgTree, moveVehiclesBetweenOrgs } from "@/services/API.js";

import { AmplifyEventBus } from "aws-amplify-vue"

import { Logger } from "aws-amplify";
	const logger = new Logger("MoveVehicleBetweenOrg");

export default {
  name: 'MoveVehicleBetweenOrg',
  props: {
    orgs: {
      type: Array,
      required: true
    },
    vehicleList: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedOrg: null,
      selectedGroup: null,
      orgTreeLoading: false,
      orgGroups: [],
      loading: false
    }
  },
  
  computed: {
    orgNameAndIdList() {
      const orgs = this.orgs.map((org) => ({
        name: org.name,
        id: org.id,
        disabled: org.disabled
      }));

      return orgs;
    },

    disableSubmit() {
      return !this.selectedGroup || !this.selectedOrg ? true : false;
    },

    vehicleIdList() {
      const vehicles = this.vehicleList.map(vehicle => vehicle.id)

      return vehicles
    },

    payload() {
      const payload = {
        target: {
          org_id: this.selectedOrg,
          node_id: this.selectedGroup
        },
        vehicles: this.vehicleIdList
      }

      return payload
    }
  },

  watch: {
    selectedOrg(id) {
      this.selectedGroup = null;
      this.fetchOrgNodes(id);
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async moveVehicles() {
      this.loading = true 

      try {
        const move = await moveVehiclesBetweenOrgs(this.selectedOrg, this.payload)

        if (move) {
          this.loading = false
          this.$emit('success')
          AmplifyEventBus.$emit("snackEvent", {
            color: "success",
            text: 'Vehicle(s) successfully moved to target organisation'
          })
        }
      } catch {
        this.loading = false
        
        AmplifyEventBus.$emit("snackEvent", {
          color: "error",
          text: 'An error occured'
        })
      }
    },

    async fetchOrgNodes(id) {
        this.orgTreeLoading = true;

        try {
          const orgTree = await GetOrgTree(id);

          if (orgTree && orgTree.hasOwnProperty('root_node')) {
            this.orgGroups =  this.flattenOrgTree([orgTree.root_node]);
            this.orgTreeLoading = false;
          }
        } catch {
          this.orgTreeLoading = false;
          AmplifyEventBus.$emit("snackEvent", {
            color: "error",
            text: 'An error occured'
          })
        }
				
			},

    flattenOrgTree(node) {
      try {
        var result = [];

        node.forEach((a) => {
          result.push({
            name: a.metadata.label,
            id: a.id
          });
          if (Array.isArray(a.nodes)) {
            let nextNode = this.flattenOrgTree(a.nodes)
            
            result = result.concat(nextNode);
          }
      });
      return result;

      } catch (err) {
        logger.info('error?', err)
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .move-org {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;

    .format-content {
      background: #0f74bb;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid grey 2px;
      width: 500px;

      .header {
        background: #0f74bb;
        color: white;
      }
    }
  }
</style>